export default {
  getShowProductStatusModal(state) {
    return state.showProductStatusModal;
  },
  getSingleProductDeleteRowId(state) {
    return state.singleProductDeleteRowId;
  },
  getSingleProductImageUploadRowId(state) {
    return state.singleProductImageUploadRowId;
  },
  getProductListActiveTab(state) {
    return state.productListActiveTab;
  },
  getIsProductLoading(state) {
    return state.isLoading;
  },
  getProductError(state) {
    return state.error;
  },

  // Product detail getters
  getProductDetail(state) {
    return state.productDetail.data;
  },
  isProductDetailLoading(state) {
    return state.productDetail.loading;
  },
  getProductDetailError(state) {
    return state.productDetail.error;
  },
  isProductDisabled(state) {
    const productStatus = state.productDetail.data?.productStatus;
    return productStatus === "Prohibited" || productStatus === "CatalogRejected";
  },

  // Product safety info getters
  getProductSafetyInfo(state) {
    return state.productSafetyInfo.data;
  },
  isProductSafetyInfoLoading(state) {
    return state.productSafetyInfo.loading;
  },
  getProductSafetyInfoError(state) {
    return state.productSafetyInfo.error;
  },

  getIsProductUpdate(state) {
    return state.isPriceAreaUpdate;
  },
  getIsPriceAreaStatus(state) {
    return state.isPriceAreaStatus;
  },
  getIsPriceAreaErrorMessage(state) {
    return state.isPriceAreaErrorMessage;
  },
  getActivePriceAreaInput(state) {
    return state.activePopoverId;
  },
  getSubTabsByKey(state) {
    return state.subTabsByKey;
  },

  // Product model code getters
  isProductModelCodeLoading(state) {
    return state.productModelCode.loading;
  },
  getProductModelCodeError(state) {
    return state.productModelCode.error;
  },

  // Product additional info getters
  isProductAdditionalInfoLoading(state) {
    return state.productAdditionalInfo.loading;
  },
  getProductAdditionalInfoError(state) {
    return state.productAdditionalInfo.error;
  },
  // Product sale variant info getters
  isProductSaleVariantLoading(state) {
    return state.productSaleVariant.loading;
  },
  getProductSaleVariantError(state) {
    return state.productSaleVariant.error;
  },
  
  // Product description getters
  isProductDescriptionLoading(state) {
    return state.productDescription.loading;
  },
  getProductDescriptionError(state) {
    return state.productDescription.error;
  },
};
